import { z } from 'zod';

export const WebSearchToolName = 'webSearch';

export const webSearchArgsSchema = z.object({
  searchQuery: z
    .string()
    .describe('Natural-language query for web search on allowed domains'),
  context: z
    .string()
    .nullish()
    .describe('Optional context from conversation to refine search query'),
});

export const webSearchContentSchema = z.string();

export type WebSearchArgs = z.infer<typeof webSearchArgsSchema>;
export type WebSearchContent = z.infer<typeof webSearchContentSchema>;
